import { lazy } from "react";
import type { RouteObject } from "react-router";
import { STUDENT_CENTRAL_ROUTES } from "@/src/student-central/constants/student-central-routes.constants";

const PublicStudentCentralPage = lazy(() => import("@/src/student-central/pages/public-student-central.page"));
const StudentCentralPostDetailPage = lazy(() => import("@/src/student-central/pages/post-detail.page"));
const StudentCentralPage = lazy(() => import("@/src/student-central/pages/student-central.page"));

/**
 * Public routes — mounted under `PublicLayout` (no sidebar).
 * The detail page works for both authed and unauthed viewers; composing it
 * with the public tree keeps the URL space flat (/student-central/:id).
 */
export const studentCentralPublicRoutes: RouteObject[] = [
	{ path: STUDENT_CENTRAL_ROUTES.studentCentral, element: <PublicStudentCentralPage /> },
	{ path: STUDENT_CENTRAL_ROUTES.studentCentralDetailPattern, element: <StudentCentralPostDetailPage /> },
];

/**
 * Authed routes — mounted under `AuthedLayout` → `ProtectedRoute`.
 * Gives staff / super_admin the create-post modal.
 */
export const studentCentralAuthedRoutes: RouteObject[] = [
	{ path: STUDENT_CENTRAL_ROUTES.appStudentCentral, element: <StudentCentralPage /> },
	{ path: STUDENT_CENTRAL_ROUTES.appStudentCentralDetailPattern, element: <StudentCentralPostDetailPage /> },
];
